import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import { riskMgmtListAction } from "../../../modules/riskmanagement/action";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import SummaryCard from "../../FormElement/SummaryCard";
import {
  faCalendarCheck,
  faCalendarTimes
} from "@fortawesome/free-solid-svg-icons";
import { red } from "@material-ui/core/colors";

class RiskSummaryView extends Component {
  state = {};
  componentWillMount() {
    const {
      riskMgmtListAction,
      SubFarmId = userFarmDetail().id || this.props.MainFarmId,
      selectedYear
    } = this.props;
    if (
      !isSuperAdmin() ||
      this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      riskMgmtListAction(SubFarmId, selectedYear);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      SubFarmId = userFarmDetail().id || this.props.MainFarmId
    } = this.props;
    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.riskMgmtListAction(nextProps.SubFarmId);
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() ||
        nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)
    ) {
      this.props.riskMgmtListAction(SubFarmId, nextProps.selectedYear);
    }
  }

  render() {
    const { rowRisk } = this.props;
    return (
      rowRisk.length != 0 && (
        <Grid container item xs={12}>
          <SummaryCard
            calculatedNumber={rowRisk.contractsBehindScheduled}
            message={"contracts behind scheduled"}
            icon={faCalendarTimes}
            iconColor={red[400]}
          />
          <SummaryCard
            calculatedNumber={rowRisk.contractsCompleted}
            sign={"%"}
            message={"contracts completed"}
            icon={faCalendarCheck}
          />
        </Grid>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    rowRisk: state.riskReducer.riskList,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ riskMgmtListAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RiskSummaryView);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/RiskSummaryView.js